if(!customElements.get('comment-popup')){
    class CommentPopup extends HTMLElement{
        constructor(){
            super();

            // close popup
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closePopup.bind(this));
                item.addEventListener("keydown", e => {
                    if(e.code === 'Enter'){
                        this.closePopup();
                    }
                });
            });
            this.addEventListener('click', e => {
                if(e.target === this) this.closePopup();
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.closePopup();
            });

            this.id = this.dataset.id;

            this.buttonComment = document.querySelector(`.button-comment[data-id="${this.id}"]`);
            if(this.buttonComment){
                this.buttonComment.addEventListener("click", () => {
                    this.openPopup(this.buttonComment);
                });
                this.buttonComment.addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.openPopup(this.buttonComment);
                    }
                });
            }
        }

        connectedCallback(){
            this.errors = this.querySelector(".input-error");
            if(this.errors){
                this.openPopup();
            }
        }

        openPopup(triggerElement = null){
            this.previouslyFocusedElement = triggerElement || document.activeElement;

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            FocusTrap.activate(this);
            this.addFocus();
        }

        closePopup(){
            FocusTrap.deactivate(this);

            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        addFocus(){
            setTimeout(() => {
                const focusItems = this.querySelectorAll('a', 'input');

                if(focusItems.length > 0){
                    focusItems[0].focus();
                }
            }, 100);
        }
    }

    customElements.define('comment-popup', CommentPopup);
}